import React from "react";

const UserInfoDropdown = () => (
  /* <!-- Nav Item - User Information --> */
  <li className="nav-item dropdown">
    <a
      className="nav-link dropdown-toggle"
      href="/#"
      id="userDropdown"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span className="mr-2 d-none d-lg-inline">Bienvenido, (usuario)</span>
      <img
        className="img-profile rounded-circle"
        src="https://source.unsplash.com/QAB-WJcbgJk/60x60"
        alt="circle"
      />
    </a>
    {/* <!-- Dropdown - User Information --> */}
    <div
      className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
      aria-labelledby="userDropdown"
    >
      <a className="dropdown-item" href="/#">
        <i className="fas fa-user fa-sm fa-fw mr-2"></i>
        Perfil
      </a>
      <a className="dropdown-item" href="/#">
        <i className="fas fa-cogs fa-sm fa-fw mr-2"></i>
        Configuración
      </a>
      <div className="dropdown-divider"></div>
      <a className="dropdown-item" href="/login">
        {/*data-toggle="modal" data-target="#logoutModal"> */}
        <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
        Cerrar sesión
      </a>
    </div>
  </li>
);

export default UserInfoDropdown;
